const Footer = () => {
  return (
    <footer className='footer'>
        by <a href="https://github.com/Codemon72" target="_blank" rel="noopener noreferrer">Codemon72</a> (2022)
    </footer>
  )
}

export default Footer
